import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { HttpResponseErrorInterceptor } from './interceptors/http-response-error.interceptor';
import { UserAuthorizationService } from './services/user-authorization.service';
import { AuthGuard } from './guards/auth-guard.service';
import { OfficeAuthGuard } from './guards/office-auth-guard.service';
import { LogoutComponent } from './components/logout/logout.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { LogoutCompleteComponent } from './components/logout-complete/logout-complete.component';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        TranslocoModule,
        RouterModule
    ],
    providers: [
        UserAuthorizationService,
        AuthGuard,
        OfficeAuthGuard,
        { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpResponseErrorInterceptor, multi: true },
    ],
    declarations: [
        LogoutComponent,
        AuthCallbackComponent,
        LogoutCompleteComponent
    ],
})
export class SecurityModule {

    constructor(@Optional() @SkipSelf() parentModule: SecurityModule) {
        if (parentModule) {
            throw new Error(
                'SecurityModule is already loaded. Import it in the AppModule only');
        }
    }

}
